import React, { Fragment } from 'react';
import { dateToColor, idToColor ,userColor} from "../../utils";
import styled from "styled-components";
import { colors } from "../../maps/colors";
import useZibi from "../../zibi/UseZibi";
import SensorStatus from "../SensorStatus";
import Icn from "../Icn";

const PreviewMapPointer = styled.div`
  position: absolute;
  width: 5px;
  height: 5px;
  background: ${colors.RED1};
`;

const ImageContainer = styled.div`
    position: absolute; 
    overflow: hidden; 
    left: 0; 
    right: 0;
    top: 0;
    bottom: 0;
`;

const FloorPainterBox = (props) => {
    const {
        site,
        floorPos,
        circles,
        drawCircles,
        shoppers_list,
        draw_shoppers_image,
        miniMode,
        parentWidth,
        parentHeight,
        previewMousePosition,
        indications
    } = props;

    const { imageMetadata } = site?.[floorPos]?.floor || {};
    const { url: imageUrl, horizontal, vertical, rotate, zoom, scale, opacity } = imageMetadata;

    const imageStyle = {
        transform: `translate(${horizontal}px, ${vertical}px) rotate(${rotate}deg) scale(${1 + zoom})`,
        height: `${100 + scale}%`,
        opacity,
        userDrag: 'none'
    }

    const [sensorStatuses] = useZibi('sensorStatuses');

    const getUserColor = userId => {
        const user = shoppers_list.find(u => u._id === userId);
        if (user) {
            return dateToColor(user.createdAt);
        }
        return '#ccc';
    };

    let width = site[floorPos].floor.width || 0;
    let height = site[floorPos].floor.height || 0;
    let devider = 1;
    if (miniMode && width && height && parentHeight && parentWidth) {
        const maxHeight = parentHeight / 4;
        const maxWidth = parentWidth / 4;
        if (width > height) {
            devider = width / maxWidth;
        } else {
            devider = height / maxHeight;
        }
    }

    return (
        <div
            style={{
                width: `${width / devider}px`,
                height: `${height / devider}px`
            }}>
            <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                {imageUrl && (
                    <ImageContainer>
                        <img draggable="false" src={imageUrl} style={imageStyle} />
                    </ImageContainer>
                )}
                {site[floorPos].floor.floorEdgeSteps.map((step, idx) => {
                    const sensorStatusData = sensorStatuses[step.sensorId];
                    const status = sensorStatusData?.status;
                    const statusUpdateAt = sensorStatusData?.statusUpdateAt;

                    const isMuted = step.sensor?.mute;
                    const rotate = step.rotate || 0;

                    let width = step.sensor.width / devider;
                    let height = step.sensor.height / devider;
                    if (rotate === 90 || rotate === 270) {
                        width = step.sensor.height / devider;
                        height = step.sensor.width / devider;
                    }

                    return <div
                        key={idx}
                        style={{
                            position: 'absolute',
                            height: height,
                            width: width,
                            backgroundColor: isMuted ? '#aaaaaa50' : colors.LIGHT_ORANGE,
                            display: 'flex',
                            justifyContent: 'center',
                            left: step.xFactor / devider,
                            top: step.yFactor / devider,
                            fontSize: 12 / devider || 1,
                            border: `1px solid ${isMuted ? '#aaaaaa50' : "#edbf1a"}`
                        }}>
                        <SensorStatus status={status} statusUpdateAt={statusUpdateAt} />
                        <p style={{ alignSelf: 'center', transform: `rotate(${rotate}deg)` }}>{step.sensor.boardId}</p>
                    </div>;
                })}
                {site[floorPos].floor.floorEdgeFields.map((field, idx) => {
                    return <div
                        key={idx}
                        style={{
                            position: 'absolute',
                            height: field.field.height / devider,
                            width: field.field.width / devider,
                            display: 'flex',
                            backgroundColor: colors.ORANGE,
                            justifyContent: 'center',
                            left: field.xFactor / devider,
                            top: field.yFactor / devider,
                            fontSize: 12 / devider || 1,
                            border: "1px solid #edbf1a"
                        }}>
                        <p style={{ alignSelf: 'center', textAlign: 'center' }}>{field.field.name}</p>
                    </div>;
                })}

                {site[floorPos].floor.floorEdgeCameras.map((camera, idx) => {
                    return <div
                        key={idx}
                        style={{
                            position: 'absolute',
                            height: 20 / devider,
                            width: 20 / devider,
                            display: 'flex',
                            justifyContent: 'center',
                            left: (camera.xFactor - 10) / devider,
                            top: (camera.yFactor - 10) / devider,
                            fontSize: 12 / devider || 1,
                            color: '#11111150'
                        }}>
                        <Icn style={{ color: colors.GREEN }}>camera</Icn>
                        <p style={{ alignSelf: 'center', textAlign: 'center', position: "absolute", top: 10, fontWeight: "bold" }}>{camera.camera.name}</p>
                    </div>;
                })}

                {
                    draw_shoppers_image && circles.map((circle, idx) => <div
                        key={idx}
                        style={{
                            position: 'absolute',
                            top: circle.y * 0.8,
                            left: circle.x * 0.8,
                            transform: 'translate(-50%, -50%)'
                        }}>
                        {
                            shoppers_list.find(s => s._id === circle.userId)?.imageUrl ?

                                <img style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: 20,
                                    outlineOffset: 1,
                                    outline: `1px solid ${getUserColor(circle.userId)}`,
                                    opacity: drawCircles ? 0.5 : 1
                                }} src={shoppers_list.find(s => s._id === circle.userId)?.imageUrl} />

                                :

                                <div style={{
                                    fontSize: 8,
                                    lineHeight: '40px',
                                    textAlign: 'center',
                                    width: 40,
                                    height: 40,
                                    borderRadius: 20,
                                    outlineOffset: 1,
                                    background: userColor(circle),
                                    outline: `1px solid ${userColor(circle.userId)}`
                                }}
                                >{shoppers_list.find(s => s._id === circle.userId)?.name || 'ANON'}</div>


                        }
                    </div>)
                }

                {
                    indications.map((indic, idx) => {


                        const style = {
                            width: 1,
                            height: 1,
                            borderRadius: "50%",
                            background: indic.data.color || "#000",
                            position: "absolute",
                            left: indic.data.x,
                            top: indic.data.y,
                            zIndex: 11
                        }

                        return (
                            <div
                                className="pewka"
                                key={idx + "indicationkey"}
                                style={style}
                            >
                            </div>
                        )
                    })
                }

                <svg width="100%" height="100%">
                    {drawCircles && circles.map((c, idx) => {
                        return <Fragment key={idx}>
                            <ellipse cx={c.x * 0.8} cy={c.y * 0.8} rx={c.ma} ry={c.MA}
                                style={{ stroke: getUserColor(c.userId), fill: 'none', strokeWidth: 2 }}>
                                <animateTransform attributeName="transform"
                                    attributeType="XML"
                                    type="rotate"
                                    from={`${c.a} ${c.x * 0.8} ${c.y * 0.8}`}
                                    to={`${c.a} ${c.x * 0.8} ${c.y * 0.8}`}
                                    dur="1s"
                                    repeatCount="indefinite" />
                            </ellipse>
                            <text style={{ fontSize: 8, textAlign: "center", textAnchor: "middle" }} x={c.x * 0.8}
                                y={(c.y + 2) * 0.8}>{c.name}</text>
                        </Fragment>;
                    })}
                </svg>
                {miniMode && !!previewMousePosition?.x && !!previewMousePosition?.y && !!devider && (
                    <PreviewMapPointer
                        style={{
                            left: previewMousePosition.x / devider,
                            top: previewMousePosition.y / devider
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default FloorPainterBox;